<template>
    <div class="contacts-wrapper">
        <app-header></app-header>
        <div class="contacts-content">
            <app-aside :linksArray="links"></app-aside>
            <div class="contacts-content-main">
                <app-sales-department v-if="this.$route.params.page == 'sales-department'"></app-sales-department>
                <app-supply-chains v-if="this.$route.params.page == 'supply-chains'"></app-supply-chains>
                <app-other-contacts v-if="this.$route.params.page == 'other-contacts'"></app-other-contacts>
                <app-factory-location v-if="this.$route.params.page == 'factory-location'"></app-factory-location>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "./contacts/Header";
import Aside from "./shared/Aside";
import SalesDepartment from "./contacts/SalesDepartment";
import SupplyChains from "./contacts/SupplyChains";
import OtherContacts from "./contacts/OtherContacts";
import FactoryLocation from "./contacts/FactoryLocation";
export default {
  components: {
    appHeader: Header,
    appAside: Aside,
    appSalesDepartment: SalesDepartment,
    appSupplyChains: SupplyChains,
    appOtherContacts: OtherContacts,
    appFactoryLocation: FactoryLocation
  },
  data() {
    return {
      links: [
        { name: "Sales Department", url: "/contacts/sales-department" },
        { name: "Supply Chain", url: "/contacts/supply-chains" },
        { name: "Other Contacts", url: "/contacts/other-contacts" },
        { name: "Factory Location", url: "/contacts/factory-location" }
      ]
    };
  }
};
</script>

<style scoped>
.contacts-content {
  display: flex;
}
.contacts-content-main {
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .contacts-content-main {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contacts.vue